import { render, staticRenderFns } from "./gas2.vue?vue&type=template&id=44ec9c73&scoped=true"
import script from "./gas2.vue?vue&type=script&lang=js"
export * from "./gas2.vue?vue&type=script&lang=js"
import style0 from "./gas2.vue?vue&type=style&index=0&id=44ec9c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec9c73",
  null
  
)

export default component.exports